import qrScanner from 'qr-scanner'

// Most of these use deprecated commands, so they are separated here
// to not contaminate the main postbox file.

export const scanImage = async (file: File) => {
  qrScanner.WORKER_PATH = '/qr-scanner-worker.min.js'
  const url = await qrScanner.scanImage(file)

  return url
}

export const getKeyCode = (e: any) => {
  return e.keyCode
}

export const execCommand = (text: string) => {
  document.execCommand('insertHTML', false, text?.replaceAll?.('\n', '<br />'))
}

export type Screenshot = {
  file: File
  width: number
  height: number
}
